/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Medical Parameters Creation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './medicalParametersCreationView';

export const mapStateToPropsMedParamCreation = mapStateToProps;
export const mapDispatchToPropsMedParamCreation = mapDispatchToProps;

export default connect(
  mapStateToPropsMedParamCreation,
  mapDispatchToPropsMedParamCreation
)(View);
